import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/globals.css";
import * as Sentry from "@sentry/react";
import { Auth0Bootstrap } from "./auth/Auth0Bootstrap";
import { Auth0CookieSync } from "./auth/Auth0CookieSync";

Sentry.init({
  dsn: import.meta.env.VITE_PUBLIC_SENTRY_DSN,
});

createRoot(document.getElementById("root")!).render(
  <Auth0Bootstrap>
    <Auth0CookieSync />
    <App />
  </Auth0Bootstrap>
);
